import { render, staticRenderFns } from "./ContractNew.vue?vue&type=template&id=2743a514&scoped=true&"
import script from "./ContractNew.vue?vue&type=script&lang=js&"
export * from "./ContractNew.vue?vue&type=script&lang=js&"
import style0 from "./ContractNew.vue?vue&type=style&index=0&id=2743a514&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2743a514",
  null
  
)

export default component.exports